import { useContext } from 'react'
import { integrationContext } from '@contexts'

export const useGetType = (integrationAssignments, type) => {
  const { inboundById, outboundById } = useContext(integrationContext)

  const integrationTypes =
    type === 'OUTPUT' || type === 'SUPPLEMENTAL'
      ? outboundById
      : type === 'INPUT'
        ? inboundById
        : {}
  const filtered =
    integrationTypes &&
    integrationAssignments.filter(assignment => {
      const integration = integrationTypes[assignment.integration_id]
      return integration && integration.type === type
    })
  return filtered
}
